"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NormalizeArea = void 0;

var _theming = require("@storybook/theming");

/**
 * See:
 *  https://nicksherman.com/size-by-area/ &
 *  https://piperhaywood.com/images-consistent-surface-area/
 */
var NormalizeArea = ( /*#__PURE__*/0, _theming.styled)('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['height', 'idealArea', 'width'].includes(prop);
  },
  target: "e181hb5u0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['height', 'idealArea', 'width'].includes(prop);
  },
  target: "e181hb5u0",
  label: "NormalizeArea"
})("align-items:center;display:flex;justify-content:center;&>*{--width:", function (props) {
  return props.width;
}, ";--height:", function (props) {
  return props.height;
}, ";--area:calc(var(--width) * var(--height));--ratio:", function (props) {
  return "calc(var(--ideal-area, ".concat(props.idealArea, ") / var(--area))");
}, ";--pass01:calc(calc(var(--ratio) + calc(var(--ratio) / var(--ratio))) / 2);--pass02:calc(calc(var(--pass01) + calc(var(--ratio) / var(--pass01))) / 2);--pass03:calc(calc(var(--pass02) + calc(var(--ratio) / var(--pass02))) / 2);--pass04:calc(calc(var(--pass03) + calc(var(--ratio) / var(--pass03))) / 2);--pass05:calc(calc(var(--pass04) + calc(var(--ratio) / var(--pass04))) / 2);--pass06:calc(calc(var(--pass05) + calc(var(--ratio) / var(--pass05))) / 2);--pass07:calc(calc(var(--pass06) + calc(var(--ratio) / var(--pass06))) / 2);--pass08:calc(calc(var(--pass07) + calc(var(--ratio) / var(--pass07))) / 2);width:calc(var(--width) * var(--pass08) / 2 * 1px);}");
exports.NormalizeArea = NormalizeArea;